module.exports = __webpack_public_path__ + "img/no-data_person.73d97c79.svg";